import {DomainAncestor, entityConfig} from "core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {IDomainObject} from "core/form/formUtils";
import {LovItem} from "core/metamodel/mdEntity";
import {DOCUMENTFORMAT, DOCUMENTLOCATION} from "core/document/documentDomain";
import { Observable } from "rxjs";

export type TEodMap = {[tenantId: number]: {[eodPhase: string]: boolean}};


@entityConfig()
export class JobInfo extends DomainAncestor {

  @observable name: string;
  @observable group: string;
  @observable detailComponent: string;
  @observable beanName: string;
  @observable beanMethod: string;
  @observable arguments: any[];

  @observable oldBusinessDate: Date|string;
  @observable newBusinessDate: Date|string;

  // EOD
  @observable eodMap: TEodMap;

  // InvoiceToAcc, InvoiceToTax, InvoiceToArchive
  @observable documentTypes: LovItem[];
  @observable eventType: LovItem;

  @observable limitByProfitCenter: boolean;
  @observable onlyForDomesticCustomers: boolean;
  @observable waitForTaxConfirmation: boolean;
  @observable profitCenters: LovItem[];

  @observable invoiceTypes: LovItem[];

  // InvoiceToArchive
  @observable mainDocument: LovItem<DOCUMENTLOCATION>;
  @observable mainDocumentNameExpression: string;
  @observable attachedDocuments: boolean;
  @observable archivingFormat: LovItem<DOCUMENTFORMAT>;
  @observable archiveFilenameExpression: string;

  // DownloadBankTx
  @observable tenants: LovItem[];
  @observable bankApiTypes: LovItem[];

  // Queue 
  @observable limit: number;
  @observable queueTypes: LovItem[];


  // DataImport
  @observable importType: LovItem;
  @observable directory: string;
  @observable filenamePattern: string;

  // BrimMessageImport
  @observable invalidate: number;

  constructor(json: IDomainObject) {
    super(json);
  }

}

@entityConfig()
export class TriggerInfo extends DomainAncestor {

  @observable name: string;
  @observable group: string;
  @observable cronExpression: string;
  @observable misfirePolicy: LovItem;
  @observable addHolidayCalendar: boolean;
  @observable previousRun: Date|string;
  @observable nextRun: Date|string;
  @observable state: string;

  constructor(json: any) {
    super(json);
  }

}



// WEBPACK FOOTER //
// ./src/core/job/jobDomain.ts